<template>
  <Head title="Cadastre-se" />
  <form class="mt-1 w-full max-w-lg" @submit.prevent="register">
    <div class="py-12 px-10">
      <h1 class="text-3xl">Cadastre-se como profissional da saúde</h1>
      <div class="mt-4">
        Seja encontrado por pacientes de todo o país
      </div>
      <photo-input v-model="form.photo" :error="form.errors.photo" class="mt-10 w-full" type="file" label="Foto" />
      <div class="flex flex-wrap">
        <text-input v-model="form.name" :error="form.errors.name" class="mt-6 w-full lg:pr-6" label="Nome" />

        <mask-input v-model="form.cpf" mask="###.###.###-##" :error="form.errors.cpf" class="mt-6 w-full lg:pr-6 lg:w-1/2" label="CPF" />
        <mask-input v-model="form.cnpj" mask="##.###.###/####-##" :error="form.errors.cnpj" class="mt-6 w-full lg:w-1/2" label="CNPJ" />
        <email-input v-model="form.email" :error="form.errors.email" class="mt-6 w-full" label="E-mail" type="email" autocapitalize="off" />

        <date-input v-model="form.birthdate" :error="form.errors.birthdate" class="mt-6 w-full lg:pr-6 lg:w-1/2" label="Data de Nascimento" />
        <select-input v-model="form.sex" :error="form.errors.sex" class="mt-6 w-full lg:w-1/2" label="Gênero">
          <option :value="null" />
          <option v-for="(value, name, index) in sex_options" :key="name" :value="name">{{ value }}</option>
        </select-input>

        <vue-select-input
          v-model="form.specialties"
          :multiple="true"
          :options="getFilteredSpecialties()"
          :error="form.errors.specialties"
          class="mt-6 w-full"
          label="Especialidades"
          text="nenhuma especialidade encontrada"
        />
        <div v-if="form.specialties.length" class="mt-6 flex flex-col text-center w-full">
          <div class="flex flex-nowrap bg-gray-100/50 p-4">
            <div class="w-full lg:w-1/2">Especialidade</div>
            <div class="w-full lg:w-1/2">RQE</div>
          </div>
          <div v-for="(specialty, specialty_index) in form.specialties" class="flex flex-nowrap px-4 py-2">
            <div class="w-full lg:w-1/2">{{ specialty.name }}</div>
            <div class="w-full lg:w-1/2">
              <text-input v-model="specialty.rqe" :error="form.errors[`specialties.`+specialty_index+`.rqe`]" class="w-full" />
            </div>
          </div>
        </div>

        <h2 class="w-full mt-6">Conselho Profissional</h2>
        <select-input v-model="form.class_entity" :error="form.errors.class_entity" class="mt-6 w-full lg:w-1/3 lg:pr-6" label="Órgão">
          <option :value="null" />
          <option v-for="(value, name, index) in class_entity_options" :key="name" :value="name">{{ value }}</option>
        </select-input>
        <text-input v-model="form.class_number" :error="form.errors.class_number" class="mt-6 w-full lg:w-1/3 lg:pr-6" label="Número" />
        <select-input v-model="form.uf" :error="form.errors.uf" class="mt-6 w-full lg:w-1/3" label="UF">
          <option :value="null" />
          <option v-for="(value, name, index) in states_options" :key="name" :value="name">{{ value }}</option>
        </select-input>
        <h2 class="w-full mt-6">Endereço</h2>
        <cep-input @updateAddress="(...args) => this.onUpdateAddress(form.address,...args)" v-model="form.address.postcode" :error="form.errors[`address.postcode`]" class="mt-6 w-full lg:pr-6 lg:w-1/2" label="CEP" />
        <text-input v-model="form.address.street" :error="form.errors[`address.street`]" class="mt-6 w-full lg:w-1/2" label="Logradouro" />
        <text-input v-model="form.address.number" :error="form.errors[`address.number`]" class="mt-6 w-full lg:pr-6 lg:w-1/2" label="Número" />
        <text-input v-model="form.address.complement" :error="form.errors[`address.complement`]" class="mt-6 w-full lg:w-1/2" label="Complemento" />
        <text-input v-model="form.address.neighborhood" :error="form.errors[`address.neighborhood`]" class="mt-6 lg:pr-6 w-full lg:w-1/3" label="Bairro" />
        <text-input v-model="form.address.city" :error="form.errors[`address.city`]" class="mt-6 lg:pr-6 w-full lg:w-1/3" label="Cidade" />
        <select-input v-model="form.address.state" :error="form.errors[`address.state`]" class="mt-6 w-full lg:w-1/3" label="Estado">
          <option :value="null" disabled class="hidden invisible">Estado</option>
          <option v-for="(value, name, index) in states_options" :key="name" :value="name">{{ value }}</option>
        </select-input>
        <mask-input :mask="['(##) ####-####', '(##) #####-####']" :clear-incomplete="true" v-model="form.address.phone" :error="form.errors[`address.phone`]" class="mt-6 w-full lg:w-1/2 lg:pr-6" label="Telefone" />
        <mask-input :mask="['(##) #####-####']" :clear-incomplete="true" v-model="form.phone_mobile" :error="form.errors.phone_mobile" class="mt-6 w-full lg:w-1/2" label="Celular" />
        <password-input :showPasswordRequirements="true" @updatePasswordStatus="(passwordIsValid) => this.passwordIsValid = passwordIsValid" v-model="form.password" :error="form.errors.password" class="mt-6 w-full" label="Senha" />
        <switch-input v-model="form.create_patient" class="w-full mt-6" labelChecked="Criar conta também como paciente ah.life" labelUnchecked="Criar conta também como paciente ah.life" />
      </div>
      <loading-button :loading="form.processing" class="btn-primary w-full mt-6 justify-center" type="submit">Concluir</loading-button>
    </div>
  </form>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import TextInput from '@/Shared/Fields/TextInput'
import PasswordInput from '@/Shared/Fields/PasswordInput'
import LoadingButton from '@/Shared/Components/LoadingButton'
import Layout from '@/Pages/Auth/Professional/Layout'
import SelectInput from '@/Shared/Fields/SelectInput'
import MaskInput from '@/Shared/Fields/MaskInput'
import PhotoInput from '@/Shared/Fields/PhotoInput'
import VueSelectInput from '@/Shared/Fields/VueSelectInput'
import EmailInput from '@/Shared/Fields/EmailInput'
import SwitchInput from '@/Shared/Fields/SwitchInput'
import DateInput from '@/Shared/Fields/DateInput'
import CepInput from '@/Shared/Fields/CepInput'

export default {
  props: {
    sex_options: Object,
    specialties: Array,
    states_options: Object,
    class_entity_options: Object,
  },
  layout: Layout,
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    PasswordInput,
    SelectInput,
    MaskInput,
    PhotoInput,
    VueSelectInput,
    EmailInput,
    SwitchInput,
    DateInput,
    CepInput,
  },
  data() {
    return {
      passwordIsValid: false,
      form: this.$inertia.form({
        name: '',
        email: '',
        password: '',
        cpf: '',
        cnpj: '',
        class_entity: '',
        class_number: '',
        uf: '',
        sex: '',
        phone_mobile: '',
        birthdate: null,
        create_patient: false,
        specialties: [],
        photo: null,
        address: {
          postcode: '',
          street: '',
          number: '',
          neighborhood: '',
          city: '',
          state: '',
          phone: '',
        },
      }),
    }
  },
  methods: {

    register() {

      if(this.passwordIsValid) {
        this.form.post('/register', {
          forceFormData: true,
        });
      }
    },
    onUpdateAddress(address, json) {
      address.city = json.localidade;
      address.state = json.uf;
      address.street = json.logradouro;
      address.neighborhood = json.bairro;
    },
    getFilteredSpecialties() {
      return this.specialties.filter(
        specialty =>
          !this.form.specialties.some(selected => selected.id === specialty.id)
      );
    }
  },
}
</script>
